import React from "react"
import { Link } from "gatsby"
import useMinimalConfig from "../../hooks/use-minimal-config"
import useSiteMetadata from "../../hooks/use-site-metadata"
import { createMarkup } from "../../../utils/markup-creator"
import { stripLeadingCopyright } from "../../../utils/footer-copyright"
import { FooterType } from "../../types"

type LayoutProps = {
  footer: FooterType
  [key: string]: any
}

const FooterChm = ({ footer }: LayoutProps) => {
  const { footerNavigation: nav, basePath } = useMinimalConfig()
  const { footerCopyrightText, footerPhoneNumber } = useSiteMetadata()
  const disclaimerHtml = footerCopyrightText ? stripLeadingCopyright(footerCopyrightText.toString()) : ``

  return (
    <footer className={`bg-darkBrand text-white font-inter ${footer.advanced?.class || ``}`}>
      <div className="max-w-screen-xl mx-auto px-6 lg:px-20 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-6">
          <div className="flex items-center gap-3">
            {footer.logo && <img src={footer.logo} alt="" style={{ height: `40px`, width: `39px` }} />}
            <span className="whitespace-nowrap leading-none">
              <span className="text-xl md:text-2xl">
                <span className="font-light">Christian </span>
                <span className="font-medium">Healthcare </span>
                <span className="font-bold">Plans</span>
              </span>
            </span>
          </div>
          {nav && nav.length > 0 && (
            <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-gray-400">
              {nav.map((item: any, i: number) => {
                if (item.type === `internal`) {
                  return (
                    <Link key={`fnav-${i}`} to={`/${basePath}/${item.slug}`.replace(/\/\/+/g, `/`)} className="text-gray-400 hover:text-white">
                      {item.title}
                    </Link>
                  )
                }
                return (
                  <a key={`fnav-${i}`} href={`https://www.weshare.org${item.slug}`} target="_blank" rel="noreferrer" className="text-gray-400 hover:text-white">
                    {item.title}
                  </a>
                )
              })}
            </nav>
          )}
        </div>
        <p className="mt-8 text-sm text-gray-400">
          © {new Date().getFullYear()} Unite Health Share Ministries<sup>™</sup> and WeShare<sup>®</sup>
        </p>
        {footerPhoneNumber && <p className="mt-4 text-sm text-gray-400">{footerPhoneNumber}</p>}
        {disclaimerHtml && (
          <div
            className="mt-6 text-sm text-gray-400 leading-relaxed max-w-screen-lg"
            dangerouslySetInnerHTML={createMarkup(disclaimerHtml)}
          />
        )}
      </div>
    </footer>
  )
}

export default FooterChm
